<template>
  <div class="fieldset">
    <div class="address" ref="">
      <label class="fieldset-title">Весь маршрут</label>
      <span class="map-button route-button" :class="{'map-button-pressed' : displayed}"
            title="На карте" @click="openMap">
        <img src="../image/route-button.svg">
      </span>
    </div>
    <div :id="routeMapId" v-show="displayed" style="width: 100%; height: 200px;">
    </div>
  </div>
</template>
<script>
  import utils from '@/utils'
  import {EventBus} from '@/event-bus.js';

  export default {
    name: 'Route',

    data() {
      return {
        routeMapId: '',
        displayed: false,
        routeMap: {}
      }
    },

    computed: {
      referencePoints() {
        return this.$store.getters.addresses.filter(address =>
            address.lat != null && address.lng != null
        ).map(address => {
          return [address.lat, address.lng]
        })
      }
    },

    watch: {
      referencePoints: {
        handler: function() {
          this.initMultiRoute();
        },
        deep: true
      }
    },

    created() {
      this.initMap();
    },

    methods: {
      openMap() {
        this.displayed = !this.displayed
      },

      initMap() {
        this.routeMapId = Math.random()
            .toString(36)
            .slice(2);

        ymaps.ready(() => {
          let referenceAddress = utils.getReferenceAddress()
          this.routeMap = new ymaps.Map(this.routeMapId, {
            center: [referenceAddress.lat, referenceAddress.lng],
            zoom: 11
          }, {})

          this.initMultiRoute()
        })
      },

      initMultiRoute() {
        if (!this.referencePoints || this.referencePoints.length == 0) {
          ymaps.ready(() => {
            this.routeMap.geoObjects.removeAll();
          });
          return;
        }

        ymaps.ready(() => {
          let multiRoute = new ymaps.multiRouter.MultiRoute({
            // referencePoints: [
            //   [this.referencePoints[0][0], this.referencePoints[0][1]],
            //   [this.referencePoints[this.referencePoints.length - 1][0], this.referencePoints[this.referencePoints.length - 1][1]]
            // ],
            referencePoints: this.referencePoints,
            params: {
              results: 1
            }
          }, {})
          // this.multiRoute.model.setReferencePoints(this.referencePoints)
          if (this.routeMap.geoObjects.getLength() > 0) {
            this.routeMap.geoObjects.set(0, multiRoute)
          } else {
            this.routeMap.geoObjects.add(multiRoute)
          }
          this.fitRouteInMap()
        })
      },

      fitRouteInMap() {
        if (!this.referencePoints || this.referencePoints.length == 0) {
          return
        }

        ymaps.ready(() => {
          if (this.referencePoints.length > 1) {
            let latArr = this.referencePoints.map(point => point[0])
            let lngArr = this.referencePoints.map(point => point[1])

            let minLat = latArr.reduce((min, item) => Math.min(min, item))
            let minLng = lngArr.reduce((min, item) => Math.min(min, item))
            let maxLat = latArr.reduce((max, item) => Math.max(max, item))
            let maxLng = lngArr.reduce((max, item) => Math.max(max, item))

            let bounds = [
              [minLat, minLng],
              [maxLat, maxLng]
            ]

            let containerSize = this.routeMap.container.getSize()
            if (containerSize[0] == 0 || containerSize[1] == 0) {
              containerSize = [540, 200]
            }

            let centerAndZoom = ymaps.util.bounds.getCenterAndZoom(bounds,
                containerSize,
                this.routeMap.options.get('projection')
            )

            this.routeMap.setCenter(centerAndZoom.center, centerAndZoom.zoom == 1 ? 1 : centerAndZoom.zoom - 1)
          } else {
            this.routeMap.setCenter(this.referencePoints[0], 11)
          }
        })
      }
    }
  }
</script>
